<template>
  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <div v-on="on" v-if="enableToolTip">
        <v-text-field
          v-on="computedListeners"
          v-bind="computedProps"
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0"
          @click="onClick"
          @dblclick="setCurrentDate(0)">
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
          <template v-slot:append>
            <div v-if="dayofweek" class="mt-2" style="z-index:10">{{weekDay}}</div>
            <v-menu v-if="!readonly" v-model="isShowCalendar" :close-on-content-click="false" origin="top left">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="primary"
                  elevation="0"
                  tabindex=-1
                  icon
                  dark
                  small
                  @click="onIconClick">
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <v-date-picker
                elevation="8"
                locale="jp-ja"
                v-model="calendarDate"
                :no-title="no_title"
                :day-format="date => new Date(date).getDate()"
                :max="calendarMax"
                :min="calendarMin"
                @input="onCalendarInput">
                <v-spacer></v-spacer>
                <dd-default-button dark dense @click="isShowCalendar = false">閉じる</dd-default-button>
                <v-spacer></v-spacer>
                <dd-default-button dark dense @click="setCurrentDate(1)">当日</dd-default-button>
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </template>
        </v-text-field>
      </div>
      <div v-else>
        <v-text-field
          v-on="computedListeners"
          v-bind="computedProps"
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0"
          @click="onClick"
          @dblclick="setCurrentDate(0)">
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
          <template v-slot:append>
            <div v-if="dayofweek" class="mt-2" style="z-index:10">{{weekDay}}</div>
            <v-menu v-if="!readonly" v-model="isShowCalendar" :close-on-content-click="false" origin="top left">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="primary"
                  elevation="0"
                  tabindex=-1
                  icon
                  dark
                  small
                  @click="onIconClick">
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <v-date-picker
                elevation="8"
                locale="jp-ja"
                v-model="calendarDate"
                :no-title="no_title"
                :day-format="date => new Date(date).getDate()"
                :max="calendarMax"
                :min="calendarMin"
                @input="onCalendarInput">
                <v-spacer></v-spacer>
                <dd-default-button dark dense @click="isShowCalendar = false">閉じる</dd-default-button>
                <v-spacer></v-spacer>
                <dd-default-button dark dense @click="setCurrentDate(1)">当日</dd-default-button>
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </template>
        </v-text-field>
      </div>
    </template>
    <span v-html="tooltipMessage"></span>
  </v-tooltip>
</template>
<script>
import DdDefaultButton from '@/components/DdDefaultButton'
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'
import dayjs from 'dayjs'
import date from '@/ddv2.library/date'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdDateBox',
  extends: VTextField,
  components: {
    DdDefaultButton
  },
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * タイトル表示
     */
    no_title: {
      type: Boolean,
      default: true
    },
    /**
     * 曜日表示
     */
    dayofweek: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    isShowCalendar: false,
    calendarDate: '',
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01',
    weekDay: '',
    weekDayStrJP: ['日', '月', '火', '水', '木', '金', '土']
  }),
  created () {
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(controls.InputTypes.Date)
    if (!dtl) { return }
    this.phtext = dtl.placeholder.replace('@@length@@', this.length)
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
      this.setDayOfWeek(this.innerValue)
    }
  },
  computed: {
    calendarMax () {
      if (this.max) {
        return this.max.split('/').join('-')
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min.split('/').join('-')
      }
      return undefined
    },
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        class: this.required ? ' required-item' : this.class,
        type: 'tel',
        hideDetails: 'auto',
        outlined: !this.isReadonly,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    },
    tooltipMessage () {
      return this.tooltipText + "<br><br>日付または年月のみの入力でも現在日から自動的に年月日になります。<br>例）2022年4月に入力した場合<br>1). '1'と入力⇒'2022/04/01'になります。<br>2). '5/1'と入力⇒'2022/05/01となります。<br>3). '0501'と入力⇒'2022/05/01となります。<br><br>※未入力時に入力欄ダブルクリックで当日が入力されます。"
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      if (!this.isShowCalendar) {
        this[controls.VALIDATE_METHOD]()
      }
      if (!this.hasError) {
        // this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        this.innerValue = val.split('/').join('')
      }
      const elem = this.$el.querySelector('input')
      console.log('DdDateBox.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }

        /**
         * フォーカス設定
         * @event focus
         * @type {Event}
         */
        this.$emit('focus', e)
      })
    },
    onIconClick: function (e) {
      console.log('DdDateBox.onIconClick', e, this.lazyValue)
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        var s = (complements.parseDate(this.lazyValue)).split('/')
        var d = new Date(s)
        if (isNaN(d.getDate())) {
          // 日付でない場合は処理日を設定
          this.calendarDate = date.getCurrentDate().split('/').join('-')
        } else {
          this.calendarDate = (complements.parseDate(this.lazyValue)).split('/').join('-')
        }
      } else {
        this.calendarDate = date.getCurrentDate().split('/').join('-')
      }
      // this.$nextTick().then(() => {
      //   this.isShowCalendar = !this.isShowCalendar
      // })
    },
    onCalendarInput: function (e) {
      console.log(e)
      this.innerValue = e.split('-').join('/')

      /**
       * カレンダー選択値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
      this.isShowCalendar = false
      this[controls.VALIDATE_METHOD]()
    },
    onClick: function (e) {
      this.isShowCalendar = false
    },
    complement: function () {
      const val = complements.parseDate(this.lazyValue)
      this.$set(this, 'innerValue', val)
      /**
       * 補完値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', val)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max === undefined ? this.defaultMax : this.max,
        min: this.min === undefined ? this.defaultMin : this.min
      }
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Date)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    setCurrentDate: function (overwrite) {
      if (this.readonly) return

      if (this.innerValue === undefined || this.innerValue === '' || overwrite === 1) {
        this.innerValue = date.getCurrentDate()
        this.$emit('input', this.innerValue)
        this[controls.VALIDATE_METHOD]()
      }
      this.isShowCalendar = false
    },
    setDayOfWeek: function (day) {
      if (this.dayofweek) {
        var d = day.replaceAll('/', '')
        var v = dayjs(d, 'YYYYMMDD', true).format('YYYYMMDD')
        if (d === v) {
          var date = new Date(dayjs(d, 'YYYYMMDD', true).format('YYYY/MM/DD'))
          this.weekDay = '(' + this.weekDayStrJP[date.getDay()] + ')'
        } else {
          this.weekDay = ''
        }
      }
    }
  }
}
</script>
<style scoped>
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  width: 290px !important;
  height: 336px !important;
}
</style>
